var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1044_44979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 6.2496H16.0003",
    stroke: "#2D3643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.74951 6.2496L5.49953 15.2498C5.49953 15.6477 5.65757 16.0292 5.93888 16.3105C6.2202 16.5918 6.60174 16.7499 6.99957 16.7499H12.9997C13.3976 16.7499 13.7791 16.5918 14.0604 16.3105C14.3417 16.0292 14.4998 15.6477 14.4998 15.2498L15.2498 6.2496",
    stroke: "#2D3643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75 6.24987V3.99981C7.75 3.80089 7.82902 3.61012 7.96968 3.46946C8.11033 3.32881 8.3011 3.24979 8.50002 3.24979H11.5001C11.699 3.24979 11.8898 3.32881 12.0304 3.46946C12.1711 3.61012 12.2501 3.80089 12.2501 3.99981V6.24987",
    stroke: "#2D3643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 9.99997L11.5001 13.0001M11.5001 9.99997L8.5 13.0001",
    stroke: "#2D3643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1044_44979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.072992c4425ef6cd88c82daa3eac0e62.svg";
export { ForwardRef as ReactComponent };